var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-list-item",
        _vm._g(
          {
            style: { "background-color": _vm.headerStyle },
            attrs: { "two-line": "" },
          },
          _vm.hasVariazioni ? { click: _vm.toggleshowVariazioni } : {}
        ),
        [
          _c(
            "v-list-item-content",
            [
              _c(
                "v-list-item-title",
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.misura.nomeMisura) + " "),
                    _vm.misura.descrizioneMisura
                      ? _c("span", [
                          _vm._v(" - " + _vm._s(_vm.misura.descrizioneMisura)),
                        ])
                      : _vm._e(),
                  ]),
                  _vm.hasVariazioni
                    ? _c(
                        "v-icon",
                        {
                          class: { "active-expansion": _vm.showVariazioni },
                          staticStyle: { "margin-left": "10px" },
                        },
                        [_vm._v(" mdi-chevron-down")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("v-list-item-subtitle", [
                _vm.hasVariazioni
                  ? _c("span", { staticStyle: { color: "rgb(251 68 68)" } }, [
                      _c("strong", [_vm._v("SONO PRESENTI VARIAZIONI")]),
                      _vm._v(" "),
                      _c("br"),
                    ])
                  : _vm._e(),
                _vm.misura.variazione
                  ? _c("span", [
                      _vm._v("Variazione: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.misura.segno) +
                            " " +
                            _vm._s(_vm.misura.variazione)
                        ),
                      ]),
                      _c("br"),
                    ])
                  : _vm._e(),
                _vm.misura.valoreMisura
                  ? _c("span", [
                      _vm._v("Valore misura: "),
                      _c("strong", [_vm._v(_vm._s(_vm.misura.valoreMisura))]),
                      _vm.misura.note ? _c("br") : _vm._e(),
                      _c("br"),
                    ])
                  : _vm.misura.totale
                  ? _c("span", [
                      _vm._v("Totale: "),
                      _c("strong", [_vm._v(_vm._s(_vm.misura.totale))]),
                      _vm.misura.note ? _c("br") : _vm._e(),
                      _c("br"),
                    ])
                  : _vm._e(),
                _vm.misura.note
                  ? _c("span", [
                      _c("strong", [_vm._v("Note: ")]),
                      _vm._v(_vm._s(_vm.misura.note)),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showVariazioni ? _c("v-divider") : _vm._e(),
      _vm.showVariazioni
        ? _c(
            "v-list-item",
            { style: { "background-color": "#f2f2f2" } },
            [
              (_vm.misura.variazioni || []).length > 0 && _vm.showVariazioni
                ? _c(
                    "v-list",
                    { staticClass: "selection-list" },
                    [
                      _vm._l(_vm.misura.variazioni, function (variazione, i) {
                        return [
                          _c("ItemListVariazioneOrdineMTM", {
                            key: variazione.id,
                            attrs: { variazione: variazione },
                            on: {
                              "conferma-variazione": _vm.confermaVariazione,
                            },
                          }),
                          i < _vm.misura.variazioni.length - 1
                            ? _c("v-divider")
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }